import styled from 'styled-components';

const StyledSkeleton = styled.div.attrs(() => ({
  className: ``,
}))`
  position: relative;
  display: grid;
  height: ${(props) => (props.height ? `${props.height}` : '16px')};
  width: ${(props) => (props.width ? `${props.width}` : '100%')};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '0px')};
  border-radius: 2px;

  & span {
    background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
    background-size: 400% 100%;
    animation: loading 1.4s ease infinite;
    color: transparent;
    height: 100%;
    width: 100%;
    border-radius: 2px;
  }
  & span:before {
    position: absolute;
    top: 25%;
    bottom: 0;
    background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
    background-size: 400% 100%;
    animation: loading 1.4s ease infinite;
    border: none;
    height: 100%;
    width: 100%;
  }
`;

export default StyledSkeleton;
